<template>
  <div class="page-content user-forms">
    <my-forms />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const MyForms = defineAsyncComponent(() => import('./UserForms/MyForms.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
